import type { ButtonHTMLAttributes } from "react";

import { cn } from "../utils/cn";

export function ToggleChip({
  selected,
  className,
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { selected: boolean }) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      className={cn(
        "rounded-full border px-3 py-1 text-xs max-sm:min-h-11 font-semibold transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        selected
          ? "border-lit bg-hb-purple-fill text-white"
          : "border-border bg-background text-muted-foreground hover:border-lit hover:text-foreground",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
